import { Routes, Route } from "react-router-dom";
import { cgmEnvs } from "@/tra/tancis/cgme/comn";
import { CgmeMainRouter } from "@/tra/tancis/cgme/router/CgmeMainRouter";
import { ptlEnvs } from "./ptli/comn";
import { PtliMainRouter } from "./ptli/router/PtliMainRouter";
import { TDWI1001001Q } from "@/tra/tancis/ptli/temp/dw/TDWI1001001Q";
import { EWCI1001001Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001001Q";
import { EWCI1001002Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001002Q";
import { EWCI1001006Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001006Q";
import { EWCI1001007Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001007Q";
import { EWCI1001008Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001008Q";
import { EWCI1001009Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001009Q";
import { EWCI1001010Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001010Q";
import { EWCI1001011Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001011Q";
import { EWCI1001021Q } from "@/tra/tancis/ptli/temp/dw/EWCI1001021Q";
import {EWCI9999019Q} from "@/tra/tancis/ptli/temp/dw/EWCI9999019Q";

/*
 * System main router
 * !== 시스템 메인 라우터 ==!
 */

export const Main = () => {
    return (
        <Routes>
            {/*
             * path : 웹 경로 설정, "*" 표시는 하위 모든 주소 매핑
             * element : 해당 path에 매핑될 하위 Router 컴포넌트
             */}
            <Route path={`${cgmEnvs.base}/*`} element={<CgmeMainRouter />} />
            <Route path={`${ptlEnvs.base}/*`} element={<PtliMainRouter />} />
            {/* TODO 임시 */}
            <Route path={`${ptlEnvs.base}/temp/dw/ptli9999001q`} element={<TDWI1001001Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999010q`} element={<EWCI1001001Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999011q`} element={<EWCI1001002Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999012q`} element={<EWCI1001006Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999013q`} element={<EWCI1001007Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999014q`} element={<EWCI1001008Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999019q`} element={<EWCI9999019Q />} />

            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999015q`} element={<EWCI1001009Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999016q`} element={<EWCI1001010Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999017q`} element={<EWCI1001011Q />} />
            <Route path={`${ptlEnvs.base}/temp/ewc/ptli9999018q`} element={<EWCI1001021Q />} />
        </Routes>
    );
};
